import Api from '../functions/api';

const obterMunicipios = () => {
  return Api.get('/Municipio');
};

export const MunicipioStore = {
  obterMunicipios,
};
